if(!customElements.get('product-badge')){
    class ProductBadge extends HTMLElement {
        constructor(){
            super();

            this.init();
        }

        init(){
            var productLink = this.dataset.productLink;
            productLink = productLink.split('?');
            productLink = productLink[0];
            this.productLink = `${productLink}`;

            fetch(this.productLink)
            .then(res => {
                if(!res.ok){
                    var error = new Error(res.status);
                    throw error;
                }

                return res.text();
            })
            .then(text => {
                const resultsMarkup = new DOMParser().parseFromString(text, 'text/html');
                const productInfo = resultsMarkup.querySelector('product-info');

                if (productInfo) {
                    const badge = productInfo.querySelector('.badge-block .product-badge');
                    if (badge) {
                        if(this.dataset.position){
                            badge.classList.add(`product-badge--${this.dataset.position}`);
                        }
                        if(this.dataset.borderWidth){
                            badge.style.borderWidth = `${this.dataset.borderWidth}px`;
                        }
                        if(this.dataset.borderRadius){
                            badge.style.setProperty('--border-radius', `${this.dataset.borderRadius}px`);
                        }
                        if(this.dataset.padding){
                            badge.style.setProperty('--padding', `${this.dataset.padding}px`);
                        }

                        this.innerHTML = badge.outerHTML;
                    }
                }
            })
        }
    }

    customElements.define('product-badge', ProductBadge);
}
